<template lang="pug">
div
  v-autocomplete(
    v-for="(answer, key) in answer_values"
    item-text="title"
    placeholder="Start typing to Search"
    outlined
    return-object
    v-model='input'
    :key="key"
    :label="answer.label"
    :loading="isSearchLoading"
    no-filter
    :search-input.sync="search"
    :items="autocompleteItems"
    @input="answer"
  )
</template>
<script>
import { debounce } from 'throttle-debounce'

export default {
  props: ['answer_values', 'value'],
  data() {
    return {
      search: null,
      isSearchLoading: false,
      autocompleteItems: [],
    }
  },
  computed: {
    input: {
      get() {
        return this.value
      },
      set(input) {
        this.$emit('input', input.value)
      }
    }
  },
  methods: {
    answer(val) {
      this.$emit('input', val)
    },
  },
  watch: {
    search(val) {
      let searchFunc = debounce(300, false, () => {
         // Items have already been loaded
        if (this.autocompleteItems > 0) return
        if (!val) return
        // Items have already been requested
        if (this.isSearchLoading) return

        this.isSearchLoading = true

        this.axios
          .get(this.answer_values[0].url, {
            params: {
              q: encodeURIComponent(val)
            }
          })
          .then(resp => {
            this.autocompleteItems = resp.data.items
          })
          .finally(() => {
            this.isSearchLoading = false
          })
      })

      searchFunc()
    }
  }
}
</script>